import { Trans } from '@lingui/macro';

import logo from '../../asset/MyntIntegration.gif';

const PaymentCardsOnboardingDialogToMyntStep3 = () => {
    return (
        <div className="flex flex-col gap-4 h-[477px] pb-2">
            <h2>
                <Trans>Payment card has now been activated!</Trans>
            </h2>

            <div className="flex items-center justify-center">
                <img src={logo} alt="Mynt logo" width="260" />
            </div>
            <div className="pt-6">
                <div>
                    <Trans>
                        To complete the onboarding, we need to forward you to our partner Mynt. In the onboarding you will answer
                        a few questions, confirm your identity and be able to order your first card.
                    </Trans>
                </div>
            </div>
        </div>
    );
};

export default PaymentCardsOnboardingDialogToMyntStep3;
